import React from 'react';

import {
  CssBaseline,
  Box,
  Typography,
  Container,
} from '@mui/material';
import { i18n } from '../../translate/i18n';
import { makeStyles } from '@mui/styles';

import SadIcon from '@mui/icons-material/SentimentVeryDissatisfied'

import {
  LogoText,
  Appbar,
} from './styles';


const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();

  return (
    <>
      <Appbar />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <LogoText />
        </div>
      </Container>
      <Container
        maxWidth='sm'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box m={5}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>{i18n.t('typographyPendente.name')}</Typography>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
            <Typography variant='h6'>
              {i18n.t('typographyPendente.access')}
            </Typography>
            <SadIcon style={{ marginLeft: '5px' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h6'>{i18n.t('typographyPendente.email')}</Typography>
          </div>
        </Box>
        <div style={{ display: 'flex', textAlign: 'center' }}>
          {/* <NavLinkButtonStyled variant="body2" to='/login' style={{ margin: '0 30px' }}>
            <Typography>voltar</Typography>
          </NavLinkButtonStyled> */}
          <Typography>
            {i18n.t('typographyPendente.doubt')}<a href='mailto:ilton@adm.com'>{i18n.t('typographyPendente.doubt1')}</a>
          </Typography>
        </div>
      </Container>
    </>
  );
}